import Vue from 'vue';

export default (cb) => {
  Vue.$http
    .get('CustomerGroups/count')
    .then((response) => {
      cb(null, response);
    })
    .catch((error) => {
      cb(error);
    });
};



// WEBPACK FOOTER //
// ./src/services/group/countAll.js